export default __webpack_public_path__ + "static/media/25.27f6664e.png";